import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOrderBacklogReportPage } from "src/components/views/erp/sales/reports/CustomerOrderBacklogReportPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/sales/reports/customerOrderBacklog")({
	staticData: { title: i18n.t("customer_order_backlog_report"), legacyViewKey: "customerOrderBacklogReportPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomerOrderBacklogReportPage />;
}
